import { useQuery } from '@tanstack/react-query';
import { kycApi } from '@/api/kyc';
import { useMemo } from 'react';

export const useEntitySections = ({
  entityType,
  id,
  adminView,
  referralView,
  investorId,
  referralToken,
  onSuccess
}) => {
  const getSectionsApi = useMemo(() => {
    if (entityType === 'product') {
      if (adminView) {
        return () => kycApi.getProductsSectionsForAdmin(id, investorId);
      } else if (referralView) {
        return () => kycApi.getReferralProductsSections(referralToken, id);
      } else {
        return () => kycApi.getProductsSections(id);
      }
    } else if (entityType === 'questionnaire') {
      if (adminView) {
        return () => kycApi.getQuestionnaireSectionsForAdmin(id, investorId);
      } else if (referralView) {
        return () => kycApi.getReferralQuestionnaireSections(referralToken, id);
      } else {
        return () => kycApi.getQuestionnaireSections(id);
      }
    }
    return null;
  }, [entityType, id, adminView, referralView, investorId, referralToken]);

  const queryKey = useMemo(
    () => [
      entityType === 'product' ? 'getProductsSections' : 'getQuestionnaireSections',
      id,
      referralToken,
      adminView ? investorId : undefined
    ],
    [id, entityType, adminView, referralToken, investorId]
  );

  const {
    data: res,
    isFetching,
    refetch
  } = useQuery({
    queryKey,
    queryFn: getSectionsApi,
    enabled: (referralView && !!referralToken) || !referralView,
    cacheTime: Infinity,
    onSuccess: onSuccess ? (data) => onSuccess(data) : undefined
  });

  const entity = useMemo(() => (res ? res.data : null), [res]);

  return {
    entity,
    isFetching,
    refetch
  };
};
